import { CircleAlert, Sparkles } from 'lucide-react'

import type { ConversationMessage } from '../conversations-model'
import styles from '../ConversationsPage.module.css'

function messageTime(timestamp: number) {
  return new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  }).format(timestamp)
}

export function MessageBubble({ message }: { message: ConversationMessage }) {
  const inbound = message.author === 'Patient'
  const aiAuthored = message.author === 'AI'
  return (
    <li
      className={`${styles.messageRow} ${inbound ? styles.inbound : styles.outbound} ${aiAuthored ? styles.aiMessage : ''}`}
    >
      <div className={styles.messageBubble}>
        <p>{message.content}</p>
        <div className={styles.messageMeta}>
          <span>
            {aiAuthored ? <Sparkles size={12} aria-hidden="true" /> : null}
            {message.author} · {message.channel}
          </span>
          <time dateTime={new Date(message.timestamp).toISOString()}>
            {messageTime(message.timestamp)}
          </time>
          {message.deliveryState === 'UNCONFIRMED' ? (
            <span>Delivery unconfirmed</span>
          ) : message.deliveryFailed ? (
            <span className={styles.deliveryFailed}>
              <CircleAlert size={13} aria-hidden="true" /> Delivery failed
            </span>
          ) : message.deliveryState === 'PENDING' ? (
            <span>Sending…</span>
          ) : message.deliveryState === 'SENT' && message.author === 'Staff' ? (
            <span>Sent</span>
          ) : null}
        </div>
      </div>
    </li>
  )
}
